const getThemeLabel = themeInfo =>
  themeInfo?.brandingId ?? themeInfo?.model?.name ?? 'default';

export const getThemeModelLoader = (themeInfo = { label: null }) => {
  const theme = getThemeLabel(themeInfo);
  const model = themeInfo?.model ?? {};

  return {
    theme,
    modelLoader: theme => {
      return {
        ...model,
        name: theme
      };
    }
  };
};
